"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveResource = exports.downloadAndSaveResource = exports.downloadAndShare = exports.initializeMiniApp = exports.closeMiniApp = exports.mobileScanner = exports.getUserProfile = exports.getDecryptData = exports.getEncryptData = exports.authenticateWithBiometrics = exports.canAuthenticateWithBiometrics = exports.openLink = exports.selectFileBase64 = exports.selectFile = exports.pickPhoto = exports.pickPhotoBase64 = exports.capturePhoto = exports.capturePhotoBase64 = exports.goToSettingToGrantPermission = exports.requestPhotoPermission = exports.requestCameraPermission = void 0;
var link_1 = require("../validator/link");
/**
 * Utility function to call Flutter handlers.
 * This function communicates with the Flutter app using `flutter_inappwebview.callHandler`
 * and returns the result of the call.
 *
 * @param handlerName - The name of the Flutter handler to invoke.
 * @param args - Optional arguments to pass to the Flutter handler.
 * @returns The result from the Flutter handler or logs an error on failure.
 */
var callFlutterHandler = function (handlerName_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([handlerName_1], args_1, true), void 0, function (handlerName, args) {
        var result, error_1;
        var _a;
        if (args === void 0) { args = []; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (_a = window.flutter_inappwebview).callHandler.apply(_a, __spreadArray([handlerName], args, false))];
                case 1:
                    result = _b.sent();
                    console.log("".concat(handlerName, " result:"), result);
                    return [2 /*return*/, result];
                case 2:
                    error_1 = _b.sent();
                    console.error("".concat(handlerName, " error:"), error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};
/**
 * Requests camera permission from the Flutter app.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<null>` object or `null` on failure.
 */
var requestCameraPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("requestCameraPermission")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_2 = _a.sent();
                console.log("requestCameraPermission => error:", error_2);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.requestCameraPermission = requestCameraPermission;
/**
 * Requests photo library access permission from the Flutter app.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<null>` object or `null` on failure.
 */
var requestPhotoPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("requestPhotoPermission")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_3 = _a.sent();
                console.log("requestPhotoPermission => error:", error_3);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.requestPhotoPermission = requestPhotoPermission;
/**
 * Opens the settings page in the Flutter app to allow users to manually grant permissions.
 */
var goToSettingToGrantPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, callFlutterHandler("goToSettingToGrantPermission")];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.goToSettingToGrantPermission = goToSettingToGrantPermission;
/**
 * Captures a photo and returns the image in Base64 format.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<Base64ContentModel>` object or `null` on failure.
 */
var capturePhotoBase64 = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("capturePhotoBase64")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_4 = _a.sent();
                console.log("error: ", error_4);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.capturePhotoBase64 = capturePhotoBase64;
/**
 * Captures a photo and returns the file path.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<AppFileModel>` object or `null` on failure.
 */
var capturePhoto = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("capturePhoto")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_5 = _a.sent();
                console.log("Failed to capture photo => ", error_5);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.capturePhoto = capturePhoto;
/**
 * Opens the gallery and allows the user to pick a photo in Base64 format.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<Base64ContentModel>` object or `null` on failure.
 */
var pickPhotoBase64 = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("pickPhotoBase64")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_6 = _a.sent();
                console.log("error: ", error_6);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.pickPhotoBase64 = pickPhotoBase64;
/**
 * Opens the gallery and allows the user to pick a photo, returning the file path.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<AppFileModel>` object or `null` on failure.
 */
var pickPhoto = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("pickPhoto")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_7 = _a.sent();
                console.log("pickPhoto => ", error_7);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.pickPhoto = pickPhoto;
/**
 * Opens the file picker and allows the user to select a file.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<AppFileModel>` object or `null` on failure.
 */
var selectFile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("selectFile")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_8 = _a.sent();
                console.log("Error:", error_8);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.selectFile = selectFile;
/**
 * Opens the file picker and allows the user to select a file base64.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<AppFileModel>` object or `null` on failure.
 */
var selectFileBase64 = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("selectFileBase64")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_9 = _a.sent();
                console.log("Error:", error_9);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.selectFileBase64 = selectFileBase64;
/**
 * Opens a given URL in the Flutter web view.
 *
 * @param link - The URL to open.
 * @throws An error if the link is invalid.
 */
var openLink = function (link) { return __awaiter(void 0, void 0, void 0, function () {
    var result, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(0, link_1.isValidURL)(link)) {
                    throw new Error("Invalid link");
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                result = {
                    success: true,
                    data: {
                        url: link,
                    },
                    message: "Data Return",
                };
                return [4 /*yield*/, callFlutterHandler("openLink", [result])];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_10 = _a.sent();
                console.log("error => ".concat(error_10));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.openLink = openLink;
/**
 * Checks if biometric authentication is available.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<CanModel>` object or `null` on failure.
 */
var canAuthenticateWithBiometrics = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("canAuthenticateWithBiometrics")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_11 = _a.sent();
                console.log("error => web => canAuthenticateWithBiometrics =>", error_11);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.canAuthenticateWithBiometrics = canAuthenticateWithBiometrics;
/**
 * Performs biometric authentication.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<CanModel>` object or `null` on failure.
 */
var authenticateWithBiometrics = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("authenticateBiometric")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_12 = _a.sent();
                console.log("error => web => authenticateWithBiometrics =>", error_12);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.authenticateWithBiometrics = authenticateWithBiometrics;
/**
 * Requests encrypted data from the Flutter app.
 *
 * @returns The encrypted data string or an empty string on failure.
 */
var getEncryptData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var result, error_13;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("sendEncryptedData")];
            case 1:
                result = _b.sent();
                return [2 /*return*/, result.success ? (_a = result.data) === null || _a === void 0 ? void 0 : _a.sensitive : ""];
            case 2:
                error_13 = _b.sent();
                console.log("error:", error_13);
                return [2 /*return*/, ""];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getEncryptData = getEncryptData;
/**
 * Sends encrypted data to the Flutter app for decryption.
 *
 * @param encryptData - The encrypted string.
 * @returns The decrypted data string or an empty string on failure.
 */
var getDecryptData = function (encryptData) { return __awaiter(void 0, void 0, void 0, function () {
    var result, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("receiveEncryptedData", [
                        encryptData,
                    ])];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result.success ? result.data : ""];
            case 2:
                error_14 = _a.sent();
                console.log("error:", error_14);
                return [2 /*return*/, ""];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getDecryptData = getDecryptData;
/**
 * Retrieves the user profile information from the Flutter app.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<UserProfileModel>` object or `null` on failure.
 */
var getUserProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("userProfile")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_15 = _a.sent();
                console.log("Failed to retrieve user profile => ", error_15);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getUserProfile = getUserProfile;
/**
 * Initiates a mobile QR code scanner in the Flutter app.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<string>` object or `null` on failure.
 */
var mobileScanner = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("mobileScanner")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_16 = _a.sent();
                console.log("Failed to scan QR => ", error_16);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.mobileScanner = mobileScanner;
/**
 * Closes the mini-app from the web view.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<null>` object or `null` on failure.
 */
var closeMiniApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_17;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("closeMiniApp")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_17 = _a.sent();
                console.log("Failed to close mini-app => ", error_17);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.closeMiniApp = closeMiniApp;
/**
 * Initializes the mini-app within the Flutter environment.
 *
 * This function triggers the "initializeMiniApp" handler in Flutter, allowing
 * the mini-app to perform any necessary setup operations before interacting
 * with the main application.
 *
 * @returns A promise resolving to a `JavascriptBridgeModel<InitializeMiniAppModel>`
 * object containing initialization details, or `null` on failure.
 */
var initializeMiniApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFlutterHandler("initializeMiniApp")];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_18 = _a.sent();
                console.log("Failed to initialize mini-app => ", error_18);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.initializeMiniApp = initializeMiniApp;
/**
 * Downloads and shares a file based on the provided parameters.
 *
 * @param fileUrl - The URL of the file to be downloaded.
 * @param fileType - The type of the file to be downloaded, such as "image", "doc", or "anyFile".
 * @param fileExtension - (Optional) The extension of the file, required if fileName is provided.
 * @param fileName - (Optional) The name of the file, required if fileExtension is provided.
 *
 * @returns {Promise<void | null>} - Returns a promise that resolves with void on success or null if an error occurs or required parameters are missing.
 */
var downloadAndShare = function (fileUrl, fileType, fileExtension, // Make fileExtension optional
fileName // Make fileName optional
) { return __awaiter(void 0, void 0, void 0, function () {
    var error_19;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                // Validate the parameters before calling the Flutter handler
                if (!fileUrl || !fileType) {
                    console.error("Missing required parameters. Please ensure fileUrl and fileType are provided.");
                    return [2 /*return*/, null]; // Exit if fileUrl or fileType is missing
                }
                // Optionally validate fileExtension and fileName if they are provided
                if (fileExtension && !fileName) {
                    console.error("fileName is required when fileExtension is provided.");
                    return [2 /*return*/, null]; // Exit if fileExtension is provided without fileName
                }
                return [4 /*yield*/, callFlutterHandler("downloadAndShare", [
                        fileUrl,
                        fileType,
                        fileExtension,
                        fileName,
                    ])];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_19 = _a.sent();
                console.log("Failed to downloadAndShare => ", error_19);
                return [2 /*return*/, null]; // Return null if there is an error
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.downloadAndShare = downloadAndShare;
/**
 * Downloads and saves a resource based on the provided parameters.
 *
 * @param fileUrl - The URL of the file to be downloaded and saved.
 * @param fileType - The type of the file to be downloaded and saved, such as "image", "doc", or "anyFile".
 * @param fileExtension - (Optional) The extension of the file, required if fileName is provided.
 * @param fileName - (Optional) The name of the file, required if fileExtension is provided.
 *
 * @returns {Promise<void | null>} - Returns a promise that resolves with void on success or null if an error occurs or required parameters are missing.
 */
var downloadAndSaveResource = function (fileUrl, fileType, fileExtension, // Make fileExtension optional
fileName // Make fileName optional
) { return __awaiter(void 0, void 0, void 0, function () {
    var error_20;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                // Validate the parameters before calling the Flutter handler
                if (!fileUrl || !fileType) {
                    console.error("Missing required parameters. Please ensure fileUrl and fileType are provided.");
                    return [2 /*return*/, null]; // Exit if fileUrl or fileType is missing
                }
                // Optionally validate fileExtension and fileName if they are provided
                if (fileExtension && !fileName) {
                    console.error("fileName is required when fileExtension is provided.");
                    return [2 /*return*/, null]; // Exit if fileExtension is provided without fileName
                }
                return [4 /*yield*/, callFlutterHandler("downloadAndSaveResource", [
                        fileUrl,
                        fileType,
                        fileExtension,
                        fileName,
                    ])];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_20 = _a.sent();
                console.log("Failed to downloadAndShare => ", error_20);
                return [2 /*return*/, null]; // Return null if there is an error
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.downloadAndSaveResource = downloadAndSaveResource;
/**
 * Saves a resource based on the provided parameters.
 *
 * @param fileName - The name of the file.
 * @param base64Data - The base64-encoded data of the file.
 * @param fileType - - The type of the file to be  saved, such as "image", "doc", or "anyFile".
 * @param extension - The file extension (e.g., "jpg", "pdf", etc.).
 *
 * @returns {Promise<void | null>} - Returns a promise that resolves with void on success or null if an error occurs.
 */
var saveResource = function (fileName, base64Data, fileType, extension) { return __awaiter(void 0, void 0, void 0, function () {
    var result, error_21;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                // Validate the parameters before calling the Flutter handler
                if (!fileName || !base64Data || !fileType || !extension) {
                    console.error("Missing required parameters. Please ensure fileName, base64Data, fileType, and extension are provided.");
                    return [2 /*return*/, null]; // Exit if any of the required parameters are missing
                }
                return [4 /*yield*/, callFlutterHandler("saveResource", [
                        fileName,
                        base64Data,
                        fileType,
                        extension,
                    ])];
            case 1:
                result = _a.sent();
                if (result.success) {
                    console.log("Resource saved successfully:", result.message);
                }
                else {
                    console.error("Failed to save resource:", result.message);
                }
                return [2 /*return*/, result];
            case 2:
                error_21 = _a.sent();
                console.error("Failed to save resource:", error_21);
                return [2 /*return*/, null]; // Return null if there is an error
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.saveResource = saveResource;
